import React from 'react';
const POSTER_IMG = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FTraining%20Announcements%2FMARCH%202026%20Concealed%20Carry%20Training%20in%20New%20Jersey.png&site=1856&w=600&h=800&user=1516&opt=w3';
export function HostingAndClassesSection() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-862">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-863">
        <div className="text-center mb-16" data-id="element-864">
          <h2 className="text-3xl font-bold text-brand-white uppercase tracking-wide mb-4" data-id="element-865">
            Host a Training Program, Get Free Tuitions!
          </h2>
          <p className="text-xl text-brand-teal font-medium" data-id="element-866">
            Custom Law Enforcement Programs Available Along With Upcoming NJ
            Concealed Carry Courses
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-867">
          {/* Flyer */}
          <div className="flex justify-center lg:justify-end" data-id="element-868">
            <div className="relative p-2 border border-brand-gray-700 bg-brand-black max-w-[500px]" data-id="element-869">
              <img src={POSTER_IMG} alt="Concealed Carry Training" className="block w-full h-auto object-cover" data-id="element-870" />
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand-teal z-10" data-id="element-871" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand-teal z-10" data-id="element-872" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand-teal z-10" data-id="element-873" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand-teal z-10" data-id="element-874" />
            </div>
          </div>

          {/* Text Content */}
          <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed" data-id="element-875">
            <p data-id="element-876">
              Agencies looking to host any of our training program can receive
              FREE training tuition's simply for hosting one of our courses. All
              of our training programs are custom built, researched and
              developed through our team of professional consultants who have
              backgrounds in Law Enforcement, Military and Corporate safety
              training.
            </p>
            <p data-id="element-877">
              We are able to customize our training programs for your agency,
              company or one-on-one "closed session" training as well as open
              sessions to other agencies. If you are unable to find the course
              or the time table you are looking for, contact our training
              coordinator and ask about Course Hosting Options.
            </p>
            <p data-id="element-878">
              For our business partners looking for our training and consulting
              services in areas such as Active Shooter-Workplace Violence
              training, Civilian Concealed Carry Training or Safety and Security
              Planning email us at:{' '}
              <a href="mailto:Info@apc360zone.com" className="text-brand-teal font-bold hover:text-brand-teal-light transition-colors" data-id="element-879">
                Info@apc360zone.com
              </a>
            </p>

            <div className="mt-12 p-6 border border-brand-gray-700 bg-brand-black" data-id="element-880">
              <h3 className="text-xl font-bold text-brand-white uppercase mb-4 text-center" data-id="element-881">
                Upcoming Concealed Carry Training for NJ Civilians
              </h3>
              <p className="text-brand-gray-300 text-center mb-0" data-id="element-882">
                <strong className="text-brand-white" data-id="element-883">
                  April 15, 16 & 19, 2025 (Burlew's Steak and Seafood
                  Restaurant-Top Floor) & 29 at the new Keyport Gun Range:
                </strong>{' '}
                10 Hour Complete CCW Training to include Use of Force, Basic
                Firearms Safety and 4 Hours Range to include holster draw
                techniques, continuous dry fire practice, The State of New
                Jersey CCARE Qualification course and Use of Force distance
                shooting exercises. Email us at{' '}
                <a href="mailto:Info@apc360zone.com" className="text-brand-teal hover:text-brand-teal-light transition-colors" data-id="element-884">
                  Info@apc360zone.com
                </a>{' '}
                for sign ups and detailed information!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}